import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { StepRun } from '@/types/stepRun';

interface WorkflowRunStepRuns {
    stepRunsById: Record<string, StepRun>;
}

interface StepRunsSummaryState {
    byWorkflowRunId: Record<string, WorkflowRunStepRuns>;
}

const initialState: StepRunsSummaryState = {
    byWorkflowRunId: {},
};

const stepRunsSummarySlice = createSlice({
    name: 'stepRunsSummary',
    initialState,
    reducers: {
        upsertStepRuns(state, action: PayloadAction<{ workflowRunId: string; stepRuns: StepRun[] }>) {
            const { workflowRunId, stepRuns } = action.payload;
            if (!state.byWorkflowRunId[workflowRunId]) {
                state.byWorkflowRunId[workflowRunId] = { stepRunsById: {} };
            }
            const map = state.byWorkflowRunId[workflowRunId].stepRunsById;
            for (const sr of stepRuns) {
                map[sr.id] = sr;
            }
        },
        updateStepRun(state, action: PayloadAction<StepRun>) {
            const stepRun = action.payload;
            for (const wfr of Object.values(state.byWorkflowRunId)) {
                if (wfr.stepRunsById[stepRun.id]) {
                    wfr.stepRunsById[stepRun.id] = stepRun;
                }
            }
        },
    },
});

export const stepRunsSummaryActions = stepRunsSummarySlice.actions;

export default stepRunsSummarySlice.reducer;
